import moment from 'moment';
import { useEffect, useState } from 'react';

// Re-renders the caller every `intervalMs` with a fresh "now", for UI derived from the current
// time (e.g. "outside working hours" badges) that must flip on its own at a boundary rather than
// waiting for an unrelated re-render. Pass `enabled: false` to skip the timer entirely.
export function useNow(intervalMs: number, enabled = true): moment.Moment {
  const [now, setNow] = useState(() => moment());

  useEffect(() => {
    if (!enabled) {
      return;
    }
    setNow(moment());
    const timer = setInterval(() => setNow(moment()), intervalMs);
    return () => clearInterval(timer);
  }, [intervalMs, enabled]);

  return now;
}
